<div class="hero-carousel-wrapper">
  @if (slides.length > 0) {
  <div class="hero-carousel">
    <!-- Slides Container -->
    <div class="hero-slides-container">
      @for (slide of slides; track slide.src; let i = $index) {
      @if (i === currentSlideIndex) {
      <div class="hero-slide active" [style.background-image]="'url(' + slide.src + ')'"
        [style.background-color]="'#0a1a3a'" [style.background-size]="'cover'"
        [style.background-position]="'center center'" [style.background-repeat]="'no-repeat'"
        [style.border-radius]="'28px'">
        <div class="hero-overlay">

          <!-- Content Section -->
          <div class="hero-content" [attr.data-slide]="currentSlideIndex">
            <!-- Logo Section -->
            <div class="hero-logo-section">
              <img src="assets/images/logo/cal-logo-white-2x.png" alt="CAL Bangladesh" class="hero-logo-img" />
            </div>

            <!-- Title -->
            <h1 class="hero-title" [innerHTML]="currentSlide.title"></h1>

            <!-- Subtitle -->
            <p class="hero-subtext">
              {{ currentSlide.subtitle }}
            </p>

            <!-- CTA Button -->
            <a [href]="currentSlide.link" [attr.target]="currentSlide.external ? '_blank' : '_self'"
              [attr.rel]="currentSlide.external ? 'noopener noreferrer' : null" class="hero-btn">
              {{ currentSlide.button }}
            </a>
          </div>

          <!-- Indicators -->
          <div class="carousel-indicators">
            @for (slide of slides; track slide.src; let i = $index) {
            <button class="indicator" [class.active]="i === currentSlideIndex" (click)="goToSlide(i)" type="button"
              [attr.aria-label]="'Go to slide ' + (i + 1)">
            </button>
            }
          </div>
        </div>
      </div>
      }
      }
    </div>

    <!-- Navigation Controls - Commented out -->
    <!-- <button class="carousel-control prev" (click)="prevSlide()" type="button" aria-label="Previous">
      <span>&#8249;</span>
    </button>
    <button class="carousel-control next" (click)="nextSlide()" type="button" aria-label="Next">
      <span>&#8250;</span>
    </button> -->
  </div>
  }
</div>